module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0.3em"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "padding-bottom": "0.2em",
      "border-bottom": "#f3f2f2 solid"
    }
  }, [_c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "15px"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('tab01')
      }
    }
  }, [(_vm.tab_view.tab01) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Shopping Cart")]) : _c('div', [_vm._v("Shopping Cart")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "15px"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('tab02')
      }
    }
  }, [(_vm.tab_view.tab02) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Collections")]) : _c('div', [_vm._v("Collections")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "15px",
      "text-decoration": "none",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('tab03')
      }
    }
  }, [(_vm.tab_view.tab03) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Orders "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  })]) : _c('div', [_vm._v("Orders "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "2em 1em"
    }
  }, [(_vm.tab_view.tab01) ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.tab_view.tab02) ? _c('div', [_c('div', {
    staticClass: "w-richtext"
  }, [((Object.keys(_vm.collections).length == 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have (0) collections")])]) : _vm._e(), _vm._v(" "), _vm._m(2)])]) : _vm._e(), _vm._v(" "), (_vm.tab_view.tab03) ? _c('div', [_vm._m(3)]) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "border-radius": "5px",
      "background": "#f72777",
      "margin": "0.8em 2em 0em 2em"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "color": "#ffffff",
      "margin": "1em"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "15px",
      "padding-top": "0.8em"
    }
  }, [_vm._v("A faster, easier way to shop online")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Set Up for Free")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-richtext"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v("cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "font-size": "13px",
      "margin-top": "0.9em",
      "text-transform": "inherit",
      "background-color": "#f7af13",
      "border-radius": "25px",
      "padding": "3px 10px"
    },
    attrs: {
      "href": "/register"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New Collection\r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-richtext"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v("orders")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-458d3a48"}!./src/pages/Collections/template.html
// module id = 539
// module chunks = 0